import React from "react";
import Image from "next/image";
import styles from "./JournalCard.module.scss";
import redirectTo from "../../../../utils/redirectTo";
import Button from "../../ui/button/Button";

type IJournalData = {
  activity_type: string;
  description: string;
  image: string;
  title: string;
  url: string;
};

type TJournalCard = {
  data: IJournalData;
};

const JournalCard: React.FC<TJournalCard> = ({ data }) => {
  const onClickHandler = () => {
    redirectTo(
      `${data.url}?utm_source=profile&utm_medium=journal&utm_campaign=donor_search`
    );
  };

  return (
    <>
      <div className={styles.header}>
        <h5 className={styles.cardTitle}>
          Журнал <span>DonorSearch</span>
        </h5>
      </div>

      <div className={styles.body}>
        <h6 className={styles.articleTitle}>{data.title}</h6>

        <Image
          src={data.image}
          loader={() => data.image}
          unoptimized={true}
          width={272}
          height={170}
          quality={50}
          alt={data.title}
          objectFit="cover"
        />

        <div
          className={styles.description}
          dangerouslySetInnerHTML={{ __html: data.description }}
        />
      </div>

      <div className={styles.footer}>
        <Button children={"Подробнее"} onClick={onClickHandler} />
      </div>
    </>
  );
};

export default JournalCard;
